// src/views/Form.js
import React, { useState } from 'react';

function FormIngreso() {
  const [formData, setFormData] = useState({
    pacienteRut: '',
    pacienteNombres: '',
    pacienteApellidos: '',
    pacienteFecNac: '',
    pacienteEdad: '',
    pacienteComuna: '',
    pacienteDireccion: '',
    pacienteMail: '',
    pacienteCelular: '',
    pacienteFonoCasa: '',
    pacienteDiagnostico: '',
    pacienteTutorSaludNombre: '',
    pacienteTutorSaludParentesco: '',
    pacienteTutorSaludCelular: '',
    pacienteTutorSaludMail: '',
    pacientePatologias: '',
    pacienteTutorPagoNombre: '',
    pacienteTutorPagoParentesco: '',
    pacienteTutorPagoCelular: '',
    pacienteTutorPagoMail: '',
    pacienteTutorPagoRut: '',
    pacienteTutorPagoFormaPago: '',
    pacienteTutorPagoTipoCta: '',
    pacienteTutorPagoNroCuenta: '',
    pacienteNombreRazonSocial: '',
    pacienteRutRazonSocial: '',
    pacienteGiroRazonSocial: '',
    pacienteDireccionRazonSocial: '',
    pacienteComunaRazonSocial: '',
    pacienteEstadoId: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Datos enviados:', formData);
  };

  return (
    <div>
      <h1>Formulario de Paciente</h1>
      <form onSubmit={handleSubmit}>
        {/* Paciente Datos Personales */}
        <div className="mb-3">
          <label htmlFor="pacienteRut" className="form-label">RUT</label>
          <input 
            type="text" 
            id="pacienteRut" 
            className="form-control" 
            name="pacienteRut"
            value={formData.pacienteRut} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteNombres" className="form-label">Nombres</label>
          <input 
            type="text" 
            id="pacienteNombres" 
            className="form-control" 
            name="pacienteNombres"
            value={formData.pacienteNombres} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteApellidos" className="form-label">Apellidos</label>
          <input 
            type="text" 
            id="pacienteApellidos" 
            className="form-control" 
            name="pacienteApellidos"
            value={formData.pacienteApellidos} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteFecNac" className="form-label">Fecha de Nacimiento</label>
          <input 
            type="date" 
            id="pacienteFecNac" 
            className="form-control" 
            name="pacienteFecNac"
            value={formData.pacienteFecNac} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteEdad" className="form-label">Edad</label>
          <input 
            type="number" 
            id="pacienteEdad" 
            className="form-control" 
            name="pacienteEdad"
            value={formData.pacienteEdad} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteComuna" className="form-label">Comuna</label>
          <input 
            type="text" 
            id="pacienteComuna" 
            className="form-control" 
            name="pacienteComuna"
            value={formData.pacienteComuna} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteDireccion" className="form-label">Dirección</label>
          <input 
            type="text" 
            id="pacienteDireccion" 
            className="form-control" 
            name="pacienteDireccion"
            value={formData.pacienteDireccion} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteMail" className="form-label">Correo Electrónico</label>
          <input 
            type="email" 
            id="pacienteMail" 
            className="form-control" 
            name="pacienteMail"
            value={formData.pacienteMail} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteCelular" className="form-label">Celular</label>
          <input 
            type="text" 
            id="pacienteCelular" 
            className="form-control" 
            name="pacienteCelular"
            value={formData.pacienteCelular} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteFonoCasa" className="form-label">Teléfono de Casa</label>
          <input 
            type="text" 
            id="pacienteFonoCasa" 
            className="form-control" 
            name="pacienteFonoCasa"
            value={formData.pacienteFonoCasa} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteDiagnostico" className="form-label">Diagnóstico</label>
          <input 
            type="text" 
            id="pacienteDiagnostico" 
            className="form-control" 
            name="pacienteDiagnostico"
            value={formData.pacienteDiagnostico} 
            onChange={handleChange} 
          />
        </div>

        {/* Datos del Tutor de Salud */}
        <h3>Tutor de Salud</h3>

        <div className="mb-3">
          <label htmlFor="pacienteTutorSaludNombre" className="form-label">Nombre del Tutor</label>
          <input 
            type="text" 
            id="pacienteTutorSaludNombre" 
            className="form-control" 
            name="pacienteTutorSaludNombre"
            value={formData.pacienteTutorSaludNombre} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorSaludParentesco" className="form-label">Parentesco del Tutor</label>
          <input 
            type="text" 
            id="pacienteTutorSaludParentesco" 
            className="form-control" 
            name="pacienteTutorSaludParentesco"
            value={formData.pacienteTutorSaludParentesco} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorSaludCelular" className="form-label">Celular del Tutor</label>
          <input 
            type="text" 
            id="pacienteTutorSaludCelular" 
            className="form-control" 
            name="pacienteTutorSaludCelular"
            value={formData.pacienteTutorSaludCelular} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorSaludMail" className="form-label">Correo del Tutor</label>
          <input 
            type="email" 
            id="pacienteTutorSaludMail" 
            className="form-control" 
            name="pacienteTutorSaludMail"
            value={formData.pacienteTutorSaludMail} 
            onChange={handleChange} 
          />
        </div>

        {/* Datos del Tutor de Pago */}
        <h3>Tutor de Pago</h3>

        <div className="mb-3">
          <label htmlFor="pacienteTutorPagoNombre" className="form-label">Nombre del Tutor de Pago</label>
          <input 
            type="text" 
            id="pacienteTutorPagoNombre" 
            className="form-control" 
            name="pacienteTutorPagoNombre"
            value={formData.pacienteTutorPagoNombre} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorPagoParentesco" className="form-label">Parentesco del Tutor de Pago</label>
          <input 
            type="text" 
            id="pacienteTutorPagoParentesco" 
            className="form-control" 
            name="pacienteTutorPagoParentesco"
            value={formData.pacienteTutorPagoParentesco} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorPagoCelular" className="form-label">Celular del Tutor de Pago</label>
          <input 
            type="text" 
            id="pacienteTutorPagoCelular" 
            className="form-control" 
            name="pacienteTutorPagoCelular"
            value={formData.pacienteTutorPagoCelular} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorPagoMail" className="form-label">Correo del Tutor de Pago</label>
          <input 
            type="email" 
            id="pacienteTutorPagoMail" 
            className="form-control" 
            name="pacienteTutorPagoMail"
            value={formData.pacienteTutorPagoMail} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorPagoRut" className="form-label">RUT del Tutor de Pago</label>
          <input 
            type="text" 
            id="pacienteTutorPagoRut" 
            className="form-control" 
            name="pacienteTutorPagoRut"
            value={formData.pacienteTutorPagoRut} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorPagoFormaPago" className="form-label">Forma de Pago</label>
          <input 
            type="text" 
            id="pacienteTutorPagoFormaPago" 
            className="form-control" 
            name="pacienteTutorPagoFormaPago"
            value={formData.pacienteTutorPagoFormaPago} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorPagoTipoCta" className="form-label">Tipo de Cuenta</label>
          <input 
            type="text" 
            id="pacienteTutorPagoTipoCta" 
            className="form-control" 
            name="pacienteTutorPagoTipoCta"
            value={formData.pacienteTutorPagoTipoCta} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteTutorPagoNroCuenta" className="form-label">Número de Cuenta</label>
          <input 
            type="text" 
            id="pacienteTutorPagoNroCuenta" 
            className="form-control" 
            name="pacienteTutorPagoNroCuenta"
            value={formData.pacienteTutorPagoNroCuenta} 
            onChange={handleChange} 
          />
        </div>

        {/* Datos de Razon Social */}
        <h3>Razón Social</h3>

        <div className="mb-3">
          <label htmlFor="pacienteNombreRazonSocial" className="form-label">Nombre o Razón Social</label>
          <input 
            type="text" 
            id="pacienteNombreRazonSocial" 
            className="form-control" 
            name="pacienteNombreRazonSocial"
            value={formData.pacienteNombreRazonSocial} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteRutRazonSocial" className="form-label">RUT</label>
          <input 
            type="text" 
            id="pacienteRutRazonSocial" 
            className="form-control" 
            name="pacienteRutRazonSocial"
            value={formData.pacienteRutRazonSocial} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteGiroRazonSocial" className="form-label">Giro</label>
          <input 
            type="text" 
            id="pacienteGiroRazonSocial" 
            className="form-control" 
            name="pacienteGiroRazonSocial"
            value={formData.pacienteGiroRazonSocial} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteDireccionRazonSocial" className="form-label">Dirección</label>
          <input 
            type="text" 
            id="pacienteDireccionRazonSocial" 
            className="form-control" 
            name="pacienteDireccionRazonSocial"
            value={formData.pacienteDireccionRazonSocial} 
            onChange={handleChange} 
          />
        </div>

        <div className="mb-3">
          <label htmlFor="pacienteComunaRazonSocial" className="form-label">Comuna</label>
          <input 
            type="text" 
            id="pacienteComunaRazonSocial" 
            className="form-control" 
            name="pacienteComunaRazonSocial"
            value={formData.pacienteComunaRazonSocial} 
            onChange={handleChange} 
          />
        </div>

        {/* Estado */}
        <div className="mb-3">
          <label htmlFor="pacienteEstadoId" className="form-label">Estado</label>
          <select 
            id="pacienteEstadoId" 
            className="form-control" 
            name="pacienteEstadoId"
            value={formData.pacienteEstadoId} 
            onChange={handleChange}
          >
            <option value="1">Activo</option>
            <option value="2">Inactivo</option>
          </select>
        </div>

        {/* Botón de Enviar */}
        <button type="submit" className="btn btn-primary">Enviar</button>
      </form>
    </div>
  );
}

export default FormIngreso;
